import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import LoginPart from "./LoginPart";
import MainModuleHeading from "./MainModuleHeading";
import style from "./style.module.css";
import NotificationDesktop from "./NotificationDesktop";
import Widgets from "./Widgets";
import aryaLogo from "./../../DesktopImages/Home/aryaLogo.svg";
import ProfileSwitch from "./ProfileSwitch/ProfileSwitch";
import useUserDetails from "../../CustomHooks/useUserDetails";
import useChildUserDetails from "../../CustomHooks/useChildUserDetails";
import { useDispatch } from "react-redux";
import { setChildUserInfo } from "../../Redux/ChildUserInfo/actions";
import { getAllChildren } from "../../Profile/api";
import useAllUserData from "../../CustomHooks/useAllUserData";
const MainHeader = ({
  className,
  isActive,
  stickyHeader,
  workEvenIfActive,
  userLoggedIn,
}) => {
  const history = useHistory();
  // const LinkClick = (url) =>{
  //     history.push(url)
  // }
  const dispatch = useDispatch();

  const allUserData = useAllUserData() || {};
  const { entityDetails = [] } = allUserData || {};
  // const entityDetails = JSON.parse(localStorage.getItem("parentData"));
  const { member: parentUserData = {} } = entityDetails || {};
  const userChildDetail = useChildUserDetails();
  const userDetail = useUserDetails();

  const [childrenData, setChildrenData] = useState([]);

  // useEffect(() => {
  //   if (userLoggedIn) {
  //     if (childrenData?.length == 0 && userChildDetail?.setApiHit == false) {
  //       getAllChildren(parentUserData?.id)
  //         .then((data) => {
  //           setChildrenData(data?.data || []);
  //           dispatch(
  //             setChildUserInfo({
  //               childUser: data?.data || [],
  //               setApiHit: true,
  //             })
  //           );
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });
  //     }
  //   }
  //   if (userChildDetail?.childUser?.length > 0) {
  //     setChildrenData(userChildDetail?.childUser);
  //   } else {
  //     setChildrenData([]);
  //   }
  // }, [userLoggedIn, childrenData?.length]);

  return (
    <>
      <div
        className={`${
          stickyHeader ? style["positionFixedHeader"] : ""
        } d-flex justify-content-space-between gap8 padding-left-right100  align-items-center  ${
          style["height60"]
        } ${className ? className : style["linearGradient"]}`}
      >
        <div className="align-items-center d-flex gap24  colorDark6">
          <div className={``}>
            <img
              src={aryaLogo}
              alt="logo"
              className={` cursorPointer`}
              onClick={() => {
                history.push("/");
              }}
            />
          </div>
          <div className={`d-flex ${style["gap32"]}`}>
            <MainModuleHeading
              isActive={isActive}
              workEvenIfActive={workEvenIfActive}
            />
          </div>
        </div>
        <div className="d-flex align-items-center gap24">
          {userLoggedIn &&
            entityDetails && entityDetails?.length > 1  && (
              <ProfileSwitch
                userLoggedIn={userLoggedIn}
                userDetails={userDetail}
                setChildrenData={setChildrenData}
                childrenData={childrenData}
              />
            )}
          <Widgets />
          <NotificationDesktop />
          <LoginPart />
        </div>
      </div>
    </>
  );
};
export default MainHeader;
